import Vue from 'vue';
import Router from 'vue-router';

import Home from '../pages/index.vue';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'Home',
      path: '/',
      component: Home
    },
    {
      name: 'Home',
      path: '/nl',
      component: Home
    },
    {
      name: 'Home',
      path: '/en',
      component: Home
    },
    {
      name: 'Home',
      path: '/fr',
      component: Home
    }
  ]
});

export default router;
